// Shared permission constants aligned with backend (ADR-001)
export const Permissions = {
  Sites: {
    Read: 'sites.read',
    Edit: 'sites.edit',
    Delete: 'sites.delete',
    Import: 'sites.import',
    All: 'sites.all',
    Financial: {
      Read: 'sites.financial.read',
      Edit: 'sites.financial.edit',
    },
  },
  Plots: {
    Read: 'plots.read',
    Labour: {
      Read: 'plots.labour.read',
    },
    Financial: {
      Read: 'plots.financial.read',
    },
  },
  Labour: {
    Read: 'labour.read',
    Submit: 'labour.submit',
    Approve: 'labour.approve',
    Cancel: 'labour.cancel',
    Resubmit: 'labour.resubmit',
    Edit: 'labour.edit',
    All: 'labour.all',
    Prices: {
      Read: 'labour.prices.read',
      Edit: 'labour.prices.edit',
    },
    Groups: {
      Read: 'labour.groups.read',
      Manage: 'labour.groups.manage',
    },
    VariationImages: {
      Read: 'labour.variation_images.read',
    },
    BookingImages: {
      Read: 'labour.booking_images.read',
    },
  },
  Users: {
    Read: 'users.read',
    Invite: 'users.invite',
    Manage: 'users.manage',
    ManageAdmins: 'users.manage_admins',
    PaymentDetails: {
      Read: 'users.payment_details.read',
    },
  },
  Organisation: {
    Read: 'organisation.read',
    Manage: 'organisation.manage',
    Details: {
      Read: 'organisation.details.read',
      Manage: 'organisation.details.manage',
    },
  },
  Portal: {
    Access: 'portal.access',
  },
  Features: {
    Read: 'features.read',
    Manage: 'features.manage',
  },
  Gangs: {
    Read: 'gangs.read',
    Create: 'gangs.manage',
  },
  Pots: {
    Read: 'pots.read',
    Submit: 'pots.submit',
    Approve: 'pots.approve',
    Reject: 'pots.reject',
    Pay: 'pots.pay',
    Move: 'pots.move',
    Extend: 'pots.extend',
    All: {
      Read: 'pots.all.read',
    },
  },
  Deductions: {
    Manage: 'deductions.manage',
    Approve: 'deductions.approve',
    Reject: 'deductions.reject',
    All: {
      Read: 'deductions.all.read',
    },
  },
  FixedRateWorkers: {
    Read: 'fixed_rate_workers.read',
    Manage: 'fixed_rate_workers.manage',
  },
  PercentageRateWorkers: {
    Read: 'percentage_rate_workers.read',
    Manage: 'percentage_rate_workers.manage',
  },
  Files: {
    Read: 'files.read',
    Write: 'files.write',
  },
  Invoices: {
    Read: 'invoices.read',
  },
  Variations: {
    Read: 'variations.read',
  },
  Allocations: {
    Read: 'allocations.read',
    Cancel: 'allocations.cancel',
    Prices: {
      Read: 'allocations.prices.read',
    },
    Admin: {
      Cancel: 'allocations.admin.cancel',
    },
  },
  Developer: {
    Access: 'developer.access',
    Time: 'developer.time',
    Jobs: {
      PotTransition: {
        Trigger: 'developer.jobs.pot-transition.trigger',
      },
      InvoiceGeneration: {
        Trigger: 'developer.jobs.invoice-generation.trigger',
      },
      NotificationDefinitions: {
        Trigger: 'developer.jobs.notification-definitions.trigger',
      },
      PushNotifications: {
        Trigger: 'developer.jobs.push-notifications.trigger',
      },
    },
    Pots: {
      Reset: 'developer.pots.reset',
    },
  },
  Platform: {
    Organisations: {
      Manage: 'platform.organisations.manage',
    },
    Features: {
      Read: 'platform.features.read',
    },
  },
} as const;

export const Roles = {
  Owner: 'Owner',
  Admin: 'Admin',
  Supervisor: 'Supervisor',
  Contractor: 'Contractor',
  Offboarding: 'Offboarding',
} as const;

export type Permission = string;
export type Role = (typeof Roles)[keyof typeof Roles];

